import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { IToasterMessage, IToasterOptions } from "../models/common";

@Injectable({
  providedIn: "root",
})

export class ToasterService {
  private toasterSubscription = new Subject<any>();
  defaultOptions: IToasterOptions = {
    timeout: 4000,
    top: 84,
    right: 20
  };

  pop(message: IToasterMessage, options?: IToasterOptions) {
    let combinedOptions = {...this.defaultOptions, ...options};
    let obj = {
      options: combinedOptions,
      message
    };
    this.toasterSubscription.next(obj);
  }

  onPop() {
    return this.toasterSubscription.asObservable();
  }

  scriptEditorOptions = {
    height: '26px',
    backgroundColor: 'white'
  };

}
